import { Empty, Flex } from 'antd'
import React from 'react'

export const PlaceholderEmpty: React.FC = () => {
  return (
    <>
      <Flex className="w-full h-full" align="center" justify="center">
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={
            <Flex vertical gap={8}>
              <div>This is your agent's template software</div>
              <div>Templates will appear here once they're available</div>
            </Flex>
          }
        />
      </Flex>
    </>
  )
}
